import React, { Component } from "react";
import { connect } from "react-redux";
import { setLocale } from "react-redux-i18n";
import { navigate } from "../../store/navigation/operations";
import { isLoggedIn } from "../../store/iam/selectors";
import PublicTopNav from "./PublicTopNav";
import AuthTopNav from "./AuthTopNav";

export class TopNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDrawerOpen: false,
      showLoginDialog: false,
    };
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.handleCloseLogin = this.handleCloseLogin.bind(this);
  }

  toggleDrawer = () => {
    this.setState({ isDrawerOpen: !this.state.isDrawerOpen });
  };
  handleMenuItemClick = (clickedItem) => {
    if (["login", "sign-up"].indexOf(clickedItem) === -1) {
      this.props.navigate(`/${clickedItem}`);
    }
    if (clickedItem === "login") {
      this.setState({ showLoginDialog: true });
    }
  };
  handleCloseLogin() {
    this.setState({ showLoginDialog: false });
  }
  render() {
    return (
      <div>
        {this.props.isLoggedIn && <AuthTopNav />}
        {!this.props.isLoggedIn && <PublicTopNav />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  currentPage: state.router.location.pathname,
  isLoggedIn: isLoggedIn(state),
});
const mapDispatchToProps = (dispatch) => ({
  setLocale: (lang) => dispatch(setLocale(lang)),
  navigate: (to) => dispatch(navigate(to)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TopNav);
